import api from './api';

export default async function createKeyword(body) {
    const { data } = await api.post(`misspelling-keyword/`, body);

    return data;
}